// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"106":"758e9248","348":"eabd023b","351":"3e6c6060","468":"5e98d0ac","516":"04f3278b","639":"bb5f4d39","643":"c5306301","761":"69713375","815":"aded593f"}[chunkId] + ".js";
};